import React from 'react';
import { mergeMessages } from '@edx/frontend-platform/i18n';
import { APP_I18N_INITIALIZED, subscribe } from '@edx/frontend-platform';

import OutlineTray from './OutlineTray';
import messages from './i18n';
import './index.scss';

subscribe(APP_I18N_INITIALIZED, () => {
  mergeMessages(messages);
});

const Plugin = (props) => (
  <OutlineTray {...props} />
);

export default Plugin;
